export default (str:string) : string => (str?.length ? str.charAt(0).toUpperCase() + str.slice(1) : '');
